import React from 'react'
import './Reasons.css'
import image1 from '../../assets/image1.png'
import image2 from '../../assets/image2.png'
import image3 from '../../assets/image3.png'
import image4 from '../../assets/image4.png'
import tick from '../../assets/tick.png'
const Reasons = () => {
  return (
    <div className='Reasons' id='reasons'>
      <div className="left-r">
        <img src={image1} alt="" />
        <img src={image2} alt="" />
        <img src={image3} alt="" />
        <img src={image4} alt="" />
      </div>
      <div className="right-r">
        <div>
            <span className='stroke-text'>why</span>
            <span> choose us?</span>
        </div>
        <div className='details-r'>
        <div><img src={tick} alt="" /><span>14+ years in Paint Industry</span></div>
        <div><img src={tick} alt="" /><span>3000+ Projects Completed</span></div>
        <div><img src={tick} alt="" /><span>Certified and Compliant Products</span></div>
        

        <div><img src={tick} alt="" /><span>Best quality at low price</span></div>
        <div><img src={tick} alt="" /><span>Great products backed by a strong R&D</span></div>
        <div><img src={tick} alt="" /><span>Highest market warranty</span></div>
        <div><img src={tick} alt="" /><span>⁠Best coverage</span></div>

        <div><img src={tick} alt="" /><span>Dedicated Customer Support</span></div>
        </div>
        {/*<span style={{color:"var(--gray)", fontWeight: "normal"}}>Our Certifications</span>
          <div className="partners">
            <img src={nb} alt="" />
            <img src={adidas} alt="" />
            <img src={nike} alt="" />
        </div>*/}
      </div>
    </div>
  )
}

export default Reasons
